import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:7071/api';

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Store for SSO result to pass to callback page
export let pendingSsoResult: AuthenticationResult | null = null;
export let msalInitialized = false;

// Process SSO login immediately when we get a response
async function processSsoLogin(idToken: string) {
  console.log('[MSAL] Processing SSO login with backend...');
  try {
    const response = await axios.post(`${API_URL}/auth/sso/login`, { idToken });
    const { token, user } = response.data;

    // Store in localStorage (same as AuthContext does)
    localStorage.setItem('teamjak_auth_token', token);
    localStorage.setItem('teamjak_user', JSON.stringify(user));

    console.log('[MSAL] SSO login successful, redirecting...');

    // Redirect based on role
    const redirectUrl = user.role === 'admin' ? '/admin' : '/';
    window.location.href = redirectUrl;
  } catch (error: any) {
    console.error('[MSAL] SSO backend error:', error.response?.data || error.message);
    // Redirect to login with error
    window.location.href = '/login?error=sso_failed';
  }
}

// Promise that resolves when MSAL is ready
export const msalReady: Promise<void> = msalInstance.initialize().then(() => {
  console.log('[MSAL] Initialized');
  msalInitialized = true;

  // Register callback for login success
  msalInstance.addEventCallback((event) => {
    console.log('[MSAL] Event:', event.eventType);
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      console.log('[MSAL] Login success, storing result');
      pendingSsoResult = event.payload as AuthenticationResult;
    }
  });

  // Handle any pending redirect
  console.log('[MSAL] Handling redirect promise...');
  return msalInstance.handleRedirectPromise().then((response) => {
    console.log('[MSAL] Redirect promise resolved:', response ? 'got response' : 'no response');
    if (response?.idToken) {
      pendingSsoResult = response;
      // Process login immediately - don't wait for React routing
      processSsoLogin(response.idToken);
    }
  });
}).catch((error) => {
  console.error('[MSAL] Initialization error:', error);
  msalInitialized = true; // Still mark as initialized so app can render
});
